import React from 'react';

export const PermissionDenied = () => (
    <div>
        <h1>Access to this page is denied!</h1>
    </div>
);